module.exports = __webpack_public_path__ + "img/bound.d19abcba.png";